import { Controller } from "@hotwired/stimulus"

// Dropdown de región del listado de cotizaciones en móvil (rediseño de Laura).
// El botón abre/cierra la lista de regiones; seleccionar una es un enlace normal
// que navega. Se cierra al clicar fuera. En desktop este bloque está oculto por
// CSS (allí la región son tabs).
//
// La portada de cotizaciones usa el mismo desplegable para sus pestañas
// (PDT-RNK-6473): allí elegir no navega, `select` marca el radio de la pestaña.
export default class extends Controller {
  static targets = ["menu", "button", "label"]

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.expanded ? this.hide() : this.show()
  }

  show() {
    this.menuTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this.closeOnOutside)
  }

  hide() {
    this.menuTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.closeOnOutside)
  }

  select(event) {
    document.getElementById(event.params.input).checked = true
    this.menuTarget.querySelectorAll("[aria-selected]").forEach((option) => {
      option.setAttribute("aria-selected", option === event.currentTarget ? "true" : "false")
    })
    this.labelTarget.textContent = event.currentTarget.textContent
    this.hide()
    this.buttonTarget.focus()
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.hide()
  }

  get expanded() {
    return this.buttonTarget.getAttribute("aria-expanded") === "true"
  }
}
